import { Roles } from "@/shared/@types/Roles";
import { AppIdentifier } from "@/shared/@types/AppIdentifier";
import { isCustomerRoleIncluded } from "@/shared/helper/isCustomerRoleIncluded.helper";

const appToRolesMappings = new Map<AppIdentifier, Array<Roles>>();

appToRolesMappings.set(AppIdentifier.FinishRegistration, [
  Roles.FLEET_AT_HOME_USER,
]);

appToRolesMappings.set(AppIdentifier.Account, [
  Roles.FBS_USER,
  Roles.FLEET_AT_HOME_USER,
  Roles.FLEET_AT_HOME_MANAGER,
  Roles.EQUIVOLT_PRE_SALES_MANAGER,
  Roles.GAS_STOREMAN,
  Roles.GAS_REQUESTER,
  Roles.GLOBAL_GAS_STOREMAN,
  Roles.THG_QUOTE_MANAGER,
  Roles.WCC_MANAGER,
  Roles.WSC_MANAGER,
  Roles.VIRTA_USER,
  Roles.GAAS_USER,
  Roles.WESTFALEN_ID_ACCOUNT_MANAGER,
]);
appToRolesMappings.set(AppIdentifier.FbsHub, [Roles.FBS_USER]);
appToRolesMappings.set(AppIdentifier.Equivolt, [
  Roles.FLEET_AT_HOME_USER,
  Roles.FLEET_AT_HOME_MANAGER,
  Roles.EQUIVOLT_PRE_SALES_MANAGER,
]);
appToRolesMappings.set(AppIdentifier.GasShop, [
  Roles.GAS_STOREMAN,
  Roles.GAS_REQUESTER,
  Roles.GAS_OCI_USER,
  Roles.GLOBAL_GAS_STOREMAN,
]);
appToRolesMappings.set(AppIdentifier.ThgQuote, [Roles.THG_QUOTE_MANAGER]);
appToRolesMappings.set(AppIdentifier.WccManagement, [Roles.WCC_MANAGER]);
appToRolesMappings.set(AppIdentifier.WscManagement, [Roles.WSC_MANAGER]);
appToRolesMappings.set(AppIdentifier.WestfalenIdAccountManagement, [
  Roles.WESTFALEN_ID_ACCOUNT_MANAGER,
]);

export const checkPermissionsByAppIdentifier = (
  appIdentifier: AppIdentifier,
  customerRoles: Array<Roles>,
) => {
  if (appIdentifier === AppIdentifier.Dashboard) return true;

  if (customerRoles.length === 0) return false;
  return isCustomerRoleIncluded(
    appIdentifier,
    appToRolesMappings,
    customerRoles,
  );
};
